module.exports = __webpack_public_path__ + "static/media/banner-home-4.8a2fa08b.jpg";